import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day1, or how strange inspiration can be",
  "description": "",
  "published": "2009-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day1-or-how-strange-inspiration-can-be/swizec/795"],
  "categories": "NaNoWriMo, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Honestly, it doesn't happen very often that inspiration would strike me at half past two in the morning and make me go do some writing rather than going to sleep. In fact, it hasn't ever happened before.`}</p>
    <p>{`So the NaNoWriMo adventure began, I didn't write quite the 1667 words required to make the 50k goal, but I did write right until the point where inspiration ran out. Let's call this a prologue, or perhaps it's not really that and it will turn out into something different. I have no idea what I'm doing here, so don't expect me to be too far ahead of anyone reading this. I'm just as much a reader here as anyone.`}</p>
    <blockquote>
      <p parentName="blockquote">{`They were somewhere around Barstow when the Bats first shouted`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      